import { Component, EventEmitter, Input, Output } from '@angular/core';
import {BlockProductCarouselNewService} from '../../block-products-carousel-new.service';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-block-header',
    templateUrl: './block-header.component.html',
    styleUrls: ['./block-header.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass, IconComponent]
})
export class BlockHeaderComponent {
    @Input() name: string;
    @Input() arrows = false;
    @Input() headers: any[] = [];
    @Input() headerIcon;

    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() prev: EventEmitter<any> = new EventEmitter();

    constructor(public blockProductCarouselService: BlockProductCarouselNewService) { }

    setHeader(header: any): void {
        this.blockProductCarouselService.changeSelectedHeader(header);
    }
}
